import React from "react";
import PropTypes from "prop-types";
// import Helmet from "react-helmet";
import { StaticQuery, graphql, Link } from "gatsby";

import Header from "./MainHeader";
import Container from "./Container";
import Nav from "./Nav";
import Image from "./Image";

const linksTo = [{
  label: "Home",
  url: "/"
}, {
  label: "Jobs",
  url: "/jobs/"
}, {
  label: "News",
  url: "/news/"
}, {
  label: "Podcast",
  url: "/podcast/"
}];

class NavigationItem extends React.PureComponent {
  render() {
    const link = this.props;
    return (
      <li className="nav-item drop-link">
        <Link to={link.url}>
          {link.label}
        </Link>
      </li>
    );
  }
}

const Layout = ({ children, data, ...rest }) => (
  <StaticQuery
    query={graphql`
    query SiteTitleQuery {
      site{
        siteMetadata{
          logo_url
          description
          title
        }
      }
    }
  `}
    render={data => {
      return (
        <React.Fragment>
          {/* <HelmetHeader data={dataHeader} /> */}
          <div id="container" className="active">
            <Header>
            {/* <Header className="second-style"> */}
              <Nav>
                <Container fluid>
                  <Link className="navbar-brand" to="/">
                    <Image src={data.site.siteMetadata.logo_url} alt="Website Logo" roundedCircle />
                    {/* <img src="images/logo.png" alt="" /> */}
                    {/* <h3>{data.site.siteMetadata.title}</h3> */}
                  </Link>
                  {/* <a className="navbar-brand" href="index.html">
                    <Image src={data.site.siteMetadata.logo_url} roundedCircle />
                    <img src="images/logo.png" alt="" />
                    <h3>{data.site.siteMetadata.title}</h3>
                  </a> */}
                  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                  </button>
                  <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav ml-auto navigate-sections">
                      {linksTo.map((link) => <NavigationItem {...link} />)}
                      {/* <li className="nav-item drop-link">
                        <Link to="/">Home</Link>
                      </li>
                      <li className="nav-item drop-link">
                        <Link to="/jobs/">Jobs</Link>
                      </li>
                      <li className="nav-item drop-link">
                        <Link to="/news/">News</Link>
                      </li>
                      <li className="nav-item drop-link">
                        <Link to="/podcast/">Podcast</Link>
                      </li> */}
                      {/* <li className="nav-item drop-link">
                        <a className="nav-link" href="#blog-section">Blog</a>
                      </li> */}
                    </ul>
                  </div>
                </Container>
              </Nav>
            </Header>
            {children}
          </div>
        </React.Fragment>
      );
    }}
  />
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout
